import { AnimatePresence, motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/contexts/CartContext";

export default function CartButton() {
  const { count, setOpen } = useCart();
  return (
    <AnimatePresence>
      {count > 0 && (
        <motion.button
          key="cart-fab"
          data-testid="cart-fab"
          onClick={() => setOpen(true)}
          initial={{ opacity: 0, y: 40, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 40, scale: 0.9 }}
          transition={{ duration: 0.35, ease: [0.19, 1, 0.22, 1] }}
          className="fixed bottom-6 right-6 z-40 flex items-center gap-3 rounded-full bg-accent px-6 py-4 font-body text-sm uppercase tracking-[0.2em] text-[var(--text)] shadow-[0_10px_30px_rgba(194,94,59,0.35)] transition-transform duration-300 hover:scale-[1.04]"
        >
          <ShoppingBag size={18} />
          <span>View Order</span>
          <span data-testid="cart-count" className="flex h-6 min-w-6 items-center justify-center rounded-full bg-black/25 px-2 text-xs">
            {count}
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
